import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function VipInclusionsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <path d="M34 6.89L20.18 2a.74.74 0 00-.5 0L5.86 6.89a.68.68 0 00-.46.64v16.05c0 2.71 1.5 5.25 4.72 8a70.44 70.44 0 008 5.55l1.38.86a.75.75 0 00.79 0l1.37-.86a70.61 70.61 0 008.05-5.56c3.22-2.74 4.72-5.28 4.72-8V7.53a.69.69 0 00-.43-.64zm-1 16.69c0 2.29-1.35 4.51-4.24 7A69.43 69.43 0 0120.91 36l-1 .61-1-.62a69.5 69.5 0 01-7.88-5.43c-2.89-2.46-4.24-4.68-4.24-7V8l13.1-4.67L33 8zM14.27 10.16a.75.75 0 00-.75.05.67.67 0 00-.29.67l1.08 6-4.58 4.25a.66.66 0 00-.18.7.71.71 0 00.58.46l6.33.88 2.83 5.47a.73.73 0 001.28 0l2.83-5.47 6.33-.88a.71.71 0 00.58-.46.66.66 0 00-.18-.7l-4.58-4.25 1.08-6a.67.67 0 00-.29-.67.75.75 0 00-.75-.05L19.93 13zM25 12l-.9 5a.67.67 0 00.21.6l3.81 3.54-5.27.73a.72.72 0 00-.54.37l-2.38 4.56-2.36-4.55a.72.72 0 00-.54-.37l-5.27-.73 3.81-3.54a.66.66 0 00.21-.6l-.9-5 4.71 2.36a.75.75 0 00.67 0z"/>
    </SvgIcon>
  )
}
export default VipInclusionsIcon
